import { IDiagnosticImageReport } from '../../../types/diagnostic-image'
import { Image, Text, View } from '@react-pdf/renderer'
import { styles } from '../styles'
import { useTranslation } from 'react-i18next'

interface AttachmentsBoxProps {
  diagnosticImages: IDiagnosticImageReport[] | undefined
  imageSources: Record<string, string>
}

const AttachmentsBox = ({
  diagnosticImages,
  imageSources,
}: AttachmentsBoxProps) => {
  const { t } = useTranslation()

  return (
    <View style={styles.mYmediumContainer}>
      <Text style={[styles.subtitle, styles.boldText, styles.underlineText]}>
        {t('sharedDiagnostic.report.attachments')}
      </Text>
      <View style={styles.gridContainer}>
        {diagnosticImages?.map((image) => (
          <Image
            key={image.id}
            src={imageSources[image.mediaUrl] ?? image.mediaUrl}
            style={styles.gridItemForFive}
          />
        ))}
      </View>
    </View>
  )
}

export default AttachmentsBox
